import { render, staticRenderFns } from "./TableNotebook.vue?vue&type=template&id=fde4d35e"
import script from "./TableNotebook.vue?vue&type=script&lang=js"
export * from "./TableNotebook.vue?vue&type=script&lang=js"
import style0 from "./TableNotebook.vue?vue&type=style&index=0&id=fde4d35e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports